export default __webpack_public_path__ + "static/media/removerequest.fc19c43e.svg";